var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDomunIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.0449 16.4906L23.8622 2.29955C21.6483 0.0846297 18.0587 0.0846297 15.8447 2.29955L1.65998 16.4906C-0.553976 18.7055 -0.553976 22.2966 1.65998 24.5116L15.8426 38.7005C18.0566 40.9154 21.6462 40.9154 23.8601 38.7005L38.0428 24.5116C40.2567 22.2966 40.2567 18.7055 38.0428 16.4906H38.0449ZM21.9702 30.3009C20.8998 31.4178 19.3925 32.1122 17.7242 32.1122C14.4775 32.1122 11.8433 29.4789 11.8433 26.2287C11.8433 22.9785 14.4775 20.3473 17.7242 20.3473C19.4448 20.3473 20.9939 21.0856 22.0685 22.2653L23.4817 23.6247C24.2573 24.2564 25.8169 25.208 27.9243 24.407L21.9702 30.2988V30.3009ZM24.019 22.6501C21.7737 20.5439 19.2712 18.0404 16.819 15.4113C14.9416 12.9496 16.4071 8.81047 19.5284 8.32524C21.2343 8.05752 22.4364 8.50302 23.7012 9.59061C25.5263 11.4709 28.3424 14.2861 30.1048 16.0095C33.9766 20.6004 28.1291 26.0384 24.019 22.6501Z",
    fill: "#94BC77"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDomunIcon);
export default __webpack_public_path__ + "static/media/domun-icon.3c47b027233316902f13573adf5b738e.svg";
export { ForwardRef as ReactComponent };